import {createAction} from 'web-app/util/redux/famly-app-helpers';

const domain = 'CONVERSATION_CENTER';

export const {action: noop} = createAction(`${domain}/NOOP`);

export const {
    action: fetch,
    success: fetchSuccess,
    failed: fetchFailed,
} = createAction(
    `${domain}/FETCH`,
    (type, archived) => ({type, archived}),
    response => ({response}),
);

export const {
    action: fetchMore,
    success: fetchMoreSuccess,
    failed: fetchMoreFailed,
} = createAction(
    `${domain}/FETCH_MORE`,
    (offset, type, archived) => ({offset, type, archived}),
    response => ({response}),
);

export const {action: hide} = createAction(`${domain}/HIDE`);

export const {action: show} = createAction(`${domain}/SHOW`);

export const {action: setInboxType} = createAction(`${domain}/SET_INBOX_TYPE`, (type, archived) => ({type, archived}));

export const {action: markConversationAsRead} = createAction(`${domain}/MARK_CONVERSATION_AS_READ`, conversationId => ({
    conversationId,
}));

export const {action: updateAndBumpConversation} = createAction(
    `${domain}/UPDATE_AND_BUMP_CONVERSATION`,
    conversation => ({
        conversation,
    }),
);
